<div class="login-page">
  <div style="width: 100%;height:5%"></div>
  <mat-toolbar class="mat-toolbar-azul">
    <img [src]="logoVisorWeb" width="250" height="auto">
    <div class="text-container" fxHide.xs fxHide.sm>
      <span>Visor de Precios CIV-DL</span>
      <span>Colegio de Ingenieros de Venezuela</span>
    </div>
    <img [src]="logoColegioIngenieros" width="150" height="150" style="position: absolute; right: 0px; top: 10px;"
      fxHide.xs>
  </mat-toolbar>

  <div>
    <ng-container *ngIf="!flag">
      <app-login-card> </app-login-card>
    </ng-container>

    <ng-container *ngIf="flag">
      <app-forgot-password> </app-forgot-password>>
    </ng-container>
  </div>
  <div style="width: 100%;height: 16%;"></div>
  <mat-toolbar style="background-color: transparent;justify-content: center;">
    <img [src]="logoDatalaing" width="250" height="auto">
  </mat-toolbar>
</div>
